import { Intercom, trackEvent, boot, shutdown, update, show } from '@intercom/messenger-js-sdk';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IntercomService {
  private appId = environment.intercom.appId; // Replace with your actual App ID

  constructor() { }

  boot(settings?: any) {
    if(window.Intercom) {
        boot({
            app_id: this.appId,
            ...settings
        });
    } else {
        Intercom({
            app_id: this.appId,
            ...settings
        });
    }
  }

  initializeUser(user
   // user: { user_id: string, email: string, name: string, created_at: number }
) {
    this.shutdown();

    this.boot(user);
  }

  update(settings?: any) {
    if(window.Intercom) {
        update(settings);
    } else {
        this.boot(settings);
    }
  }

  shutdown() {
    if(window.Intercom) {
        shutdown();
    }
  }

  trackEvent(eventName: string, metadata?: object) {
    trackEvent(eventName, metadata);
  }

  show() {
    if (window.Intercom) {
      show();
    }
  }

  isReady(): boolean {
    return !!window.Intercom;
  }
}